(function heroSliderBootstrap() {
  function initHero(hero) {
    if (!hero || hero.dataset.lkHeroInitialized === 'true') return;

    var track = hero.querySelector('.lk-hero__track');
    var dots = hero.querySelectorAll('.lk-hero__dot');
    if (!track || dots.length < 2) return;

    hero.dataset.lkHeroInitialized = 'true';

    var slides = track.querySelectorAll('.lk-hero__slide');
    var total = dots.length;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = null;
    var debounce = null;
    var firstImage = slides[0] && slides[0].querySelector('img');
    var firstReady = false;
    var autoWanted = false;
    var alive = true;
    var paintFrame = null;
    var readinessStarted = false;

    function allowFirstPaint() {
      if (!alive || !firstImage.complete || !firstImage.naturalWidth) return;
      paintFrame = requestAnimationFrame(function beforeFirstPaint() {
        if (!alive) return;
        paintFrame = requestAnimationFrame(function afterFirstPaint() {
          paintFrame = null;
          if (!alive || !firstImage.complete || !firstImage.naturalWidth) return;
          firstReady = true;
          if (autoWanted) startAuto();
        });
      });
    }

    function firstImageLoaded() {
      if (!alive || readinessStarted || !firstImage.complete || !firstImage.naturalWidth) return;
      readinessStarted = true;
      firstImage.removeEventListener('load', firstImageLoaded);
      if (typeof firstImage.decode === 'function') {
        // A loaded image may still reject decode; retain the load + paint fallback.
        try { firstImage.decode().then(allowFirstPaint, allowFirstPaint); }
        catch (error) { allowFirstPaint(); }
      } else {
        allowFirstPaint();
      }
    }

    if (firstImage) {
      firstImage.addEventListener('load', firstImageLoaded);
      firstImageLoaded();
    }

    function currentIndex() {
      return Math.max(0, Math.min(total - 1, Math.round(track.scrollLeft / (track.offsetWidth || 1))));
    }

    function hydrateDeferredSlide(index) {
      var slide = slides[index];
      if (!slide) return;
      var img = slide.querySelector('img[data-src]');
      if (!img) return;

      // Restore art-directed sources before the fallback to avoid a desktop request on mobile.
      slide.querySelectorAll('source[data-srcset]').forEach(function restoreSource(source) {
        source.setAttribute('srcset', source.getAttribute('data-srcset'));
        source.removeAttribute('data-srcset');
      });
      if (img.getAttribute('data-srcset')) {
        img.setAttribute('srcset', img.getAttribute('data-srcset'));
        img.removeAttribute('data-srcset');
      }
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
      img.setAttribute('loading', 'eager');
    }

    function selectSlide(index) {
      if (index < 0 || index >= total || !Number.isFinite(index)) return;
      hydrateDeferredSlide(index);
      track.scrollTo({ left: index * track.offsetWidth, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    }

    function startAuto() {
      if (prefersReducedMotion || !firstReady || auto !== null) return;
      hydrateDeferredSlide((currentIndex() + 1) % total);
      auto = setInterval(function advanceHero() {
        selectSlide((currentIndex() + 1) % total);
      }, 6000);
    }

    function stopAuto() {
      autoWanted = false;
      if (auto !== null) clearInterval(auto);
      auto = null;
    }

    function removeUnlockListeners() {
      document.removeEventListener('pointerdown', unlockAuto, true);
      document.removeEventListener('keydown', unlockAuto, true);
      document.removeEventListener('touchstart', unlockAuto, true);
      window.removeEventListener('scroll', unlockAuto);
    }

    function unlockAuto() {
      removeUnlockListeners();
      autoWanted = true;
      startAuto();
    }

    function selectDot() {
      stopAuto();
      selectSlide(parseInt(this.dataset.index, 10));
    }

    function prepareSwipe() {
      stopAuto();
      var index = currentIndex();
      hydrateDeferredSlide(index - 1);
      hydrateDeferredSlide(index + 1);
    }

    function prepareWheel(event) {
      if (event.deltaX) prepareSwipe();
    }

    function selectWithKeyboard(event) {
      if (event.target !== track) return;
      var index = currentIndex();
      if (event.key === 'ArrowRight') index = Math.min(index + 1, total - 1);
      else if (event.key === 'ArrowLeft') index = Math.max(index - 1, 0);
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = total - 1;
      else return;
      event.preventDefault();
      stopAuto();
      selectSlide(index);
    }

    function prepareFocusedSlide(event) {
      slides.forEach(function prepareSlide(slide, index) {
        if (slide.contains(event.target)) {
          stopAuto();
          hydrateDeferredSlide(index);
        }
      });
    }

    function updateActiveDot() {
      // A native scroll before autoplay starts is manual intent, too.
      if (auto === null) stopAuto();
      var position = track.scrollLeft / (track.offsetWidth || 1);
      // Native swipe can expose two slides before scroll snapping settles.
      hydrateDeferredSlide(Math.floor(position));
      hydrateDeferredSlide(Math.ceil(position));
      clearTimeout(debounce);
      debounce = setTimeout(function updateDotsAfterScroll() {
        var index = currentIndex();
        if (auto !== null) hydrateDeferredSlide((index + 1) % total);
        dots.forEach(function toggleActiveDot(dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }, 50);
    }

    dots.forEach(function bindDot(dot) {
      dot.addEventListener('click', selectDot);
    });
    track.addEventListener('scroll', updateActiveDot, { passive: true });
    track.addEventListener('pointerdown', prepareSwipe, { passive: true });
    track.addEventListener('touchstart', prepareSwipe, { passive: true });
    track.addEventListener('wheel', prepareWheel, { passive: true });
    track.addEventListener('keydown', selectWithKeyboard);
    track.addEventListener('focusin', prepareFocusedSlide);

    document.addEventListener('pointerdown', unlockAuto, { capture: true, passive: true });
    document.addEventListener('keydown', unlockAuto, { capture: true });
    document.addEventListener('touchstart', unlockAuto, { capture: true, passive: true });
    window.addEventListener('scroll', unlockAuto, { passive: true });

    hero.lkHeroDestroy = function destroyHero() {
      alive = false;
      if (paintFrame !== null) cancelAnimationFrame(paintFrame);
      if (firstImage) firstImage.removeEventListener('load', firstImageLoaded);
      stopAuto();
      clearTimeout(debounce);
      removeUnlockListeners();
      dots.forEach(function unbindDot(dot) {
        dot.removeEventListener('click', selectDot);
      });
      track.removeEventListener('scroll', updateActiveDot);
      track.removeEventListener('pointerdown', prepareSwipe);
      track.removeEventListener('touchstart', prepareSwipe);
      track.removeEventListener('wheel', prepareWheel);
      track.removeEventListener('keydown', selectWithKeyboard);
      track.removeEventListener('focusin', prepareFocusedSlide);
      delete hero.dataset.lkHeroInitialized;
      delete hero.lkHeroDestroy;
    };
  }

  function init(scope) {
    if (scope.matches && scope.matches('.lk-hero')) initHero(scope);
    scope.querySelectorAll('.lk-hero').forEach(initHero);
  }

  if (window.LKHeroSlider) {
    window.LKHeroSlider.init(document);
    return;
  }

  window.LKHeroSlider = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function initHeroesOnReady() {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function initReloadedHero(event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function destroyUnloadedHero(event) {
    if (event.target.matches && event.target.matches('.lk-hero') && event.target.lkHeroDestroy) {
      event.target.lkHeroDestroy();
    }
    event.target.querySelectorAll('.lk-hero').forEach(function destroyHero(hero) {
      if (hero.lkHeroDestroy) hero.lkHeroDestroy();
    });
  });
})();
